import React from 'react'
import PropTypes from 'prop-types';

const FlashNotice = ({ show, onCloseHandler, children }) => {
  if (!show) {
    return null
  }

  return (
    <div className="fixed top-0 left-0 w-full bg-grey text-white p-6 z-50 drop-shadow-lg" role="alert">
      <div className="flex max-w-4xl">
        <svg className="shrink-0 w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
          <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
        </svg>
        <div className="ms-3 text-sm font-medium pl-4 text-grey-darker flex justify-center">
          {children}
        </div>
        <button type="button" aria-label="Close" className="ml-auto text-sm flex justify-center" onClick={onCloseHandler}>
          {/* <span className="sr-only mr-4 text-sm text-grey-darker">Dismiss</span> */}
          <svg className="mt-1 w-2 h-2 text-sm" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
          </svg>
        </button>
      </div>
    </div>
  )
}

FlashNotice.propTypes = {
  show: PropTypes.bool.isRequired,
  onCloseHandler: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
}

/**
 * expose
 */

export default FlashNotice
